module.exports = __webpack_public_path__ + "static/media/public_color_add.ad5a9bf1.png";